/**
 * Lightweight class name merger — equivalent to clsx without an extra dependency.
 *
 * Accepts any number of strings, undefined/null/false values (which are ignored).
 * Use this in place of clsx/classnames throughout the app.
 *
 * @example
 * cn('base', isActive && 'active', undefined, 'always') // "base active always"
 */
export function cn(
  ...classes: Array<string | undefined | null | false | 0>
): string {
  return classes.filter(Boolean).join(' ');
}
